import React from "react";
import { STACK } from "../data";

export default function Stack() {
  return (
    <section id="stack">
      <div className="section-head">
        <div className="label">§02 · stack</div>
        <div className="h">Tools and platforms</div>
        <div className="meta"></div>
      </div>

      <div className="stack">
        <div className="stack-row h">
          <div style={{ padding: "10px 16px", borderRight: "1px solid var(--line)" }}>category</div>
          <div style={{ padding: "10px 16px" }}>tooling</div>
        </div>

        {STACK.map((row) => (
          <div className="stack-row" key={row.cat}>
            <div className="cat">
              <span className="ns">{row.ns}</span>
              <span className="n">{row.cat}</span>
            </div>
            <div className="items">
              {row.items.map((it) => (
                <span className={`chip ${it.tier}`} key={it.n}>
                  <i className="d" />
                  {it.n}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
